import DataTable from 'react-data-table-component';
import styles from './Tabela.module.scss';
import { Spinner } from 'react-bootstrap';

const Tabela = (props) => {
  const {
    columns,
    data,
    backgroundColor = '#527ac5',
    color = '#ffffff',
    pending = false,
    pagination = true,
    selectableRows = false,
    selectableRowDisabled = false,
    filterable = false,
    rowClickedFn = () => null,
    onSelectedRowsChange = () => null,
    paginationPerPage = 10,
    conditionalRowStyles = [],
    highlightOnHover = false,
    noTableHead = false,
    title = false,
    clearSelectedRows = false,
    subHeader = false,
    subHeaderComponent = null,
    rowStyles = {},
    customStylesOverrider = false,
    expandableRows = false,
    expandableRowsComponent = null,
    expandableRowsComponentProps = {},
    noDataComponent = <div style={{ padding: '10px', fontWeight: '500' }}>Nenhuma informação disponível</div>
  } = props;

  const customStyles = {
    headCells: { style: { backgroundColor: backgroundColor, justifyContent: 'center', color: color } },
    cells: { style: { justifyContent: 'center' } },
    rows: { style: { cursor: 'pointer', ...rowStyles } },
    headRow: { style: { backgroundColor: backgroundColor } }
  }

  return (
    <div className={styles.datatable_wrapper}>
      <DataTable
        title={title}
        striped={true}
        highlightOnHover={highlightOnHover}
        columns={columns}
        persistTableHead={true}
        data={data}
        pagination={pagination}
        progressPending={pending}
        progressComponent={<div style={{ padding: '10px' }}><Spinner animation={'border'} variant={'secondary'} /></div>}
        customStyles={customStylesOverrider ? customStylesOverrider : customStyles}
        noDataComponent={noDataComponent}
        onRowClicked={rowClickedFn}
        responsive={true}
        selectableRows={selectableRows}
        selectableRowDisabled={selectableRowDisabled}
        onSelectedRowsChange={onSelectedRowsChange}
        paginationPerPage={paginationPerPage}
        conditionalRowStyles={conditionalRowStyles}
        clearSelectedRows={clearSelectedRows}
        filterable={filterable}
        subHeader={subHeader}
        subHeaderComponent={subHeaderComponent}
        contextMessage={{ singular: 'item', plural: 'itens', message: 'selecionado(s)' }}
        noTableHead={noTableHead}
        expandableRows={expandableRows}
        expandableRowsComponent={expandableRowsComponent}
        expandableRowsComponentProps={expandableRowsComponentProps}
      />
    </div>
  )
}

export default Tabela;
